import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Entry } from '../../lib/api';

interface OnThisDayListProps {
  entries: Entry[];
}

export function OnThisDayList({ entries }: OnThisDayListProps) {
  const { t } = useTranslation();

  if (entries.length === 0) return null;

  return (
    <div className="flex flex-col divide-y divide-paper-200">
      {entries.map((entry) => {
        const year = new Date(entry.entryDate).getFullYear();
        return (
          <div key={entry.id} className="flex items-baseline gap-4 py-2.5">
            <span className="w-12 shrink-0 text-sm font-medium text-ink-400 tabular-nums">
              {year}
            </span>
            <div className="min-w-0 flex-1">
              <Link
                to={`/entries/${entry.id}/view`}
                className="link truncate font-medium"
              >
                {entry.title || t('today.untitled')}
              </Link>
            </div>
            {entry.wordCount != null && entry.wordCount > 0 && (
              <span className="shrink-0 text-xs text-ink-400 tabular-nums">
                {t('entries.wordCount', { count: entry.wordCount })}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
